import { render, staticRenderFns } from "./TermsScroller.vue?vue&type=template&id=1cef58ca&"
import script from "./TermsScroller.vue?vue&type=script&lang=js&"
export * from "./TermsScroller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports